var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "logo_md",
    x: "0px",
    y: "0px",
    viewBox: "0 0 332 289.7",
    style: {
      enableBackground: "new 0 0 1246.5 289.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:url(#SVGID_1_);} .st1{fill:url(#SVGID_00000173128664571964139820000008242078397182389436_);} .st2{fill:url(#SVGID_00000088114461643012627890000017991602317342007977_);} .st3{fill:url(#SVGID_00000140710677867574762010000006918747067349980299_);} .st4{fill:url(#SVGID_00000145039509002926797760000005847500484307744411_);} .st5{fill:url(#SVGID_00000083809497120650946500000006455686140988096643_);}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.89,
    y1: 221.6566,
    x2: 330.31,
    y2: 221.6566,
    gradientTransform: "matrix(1 0 0 -1 0 291.7033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#FF9933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCC33"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244,0H87.9l18.5,21.2l125.6-0.3c3.4,0,6.5,1.8,8.1,4.7l62.8,108.8l27.5,5.7L252.1,4.7 C250.5,1.8,247.4,0,244,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025438921901321760670000013112284553715653787_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.4201,
    y1: 144.3169,
    x2: 8.9701,
    y2: 150.5569,
    gradientTransform: "matrix(1 0 0 -1 0 291.7033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9933"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025438921901321760670000013112284553715653787_)"
    },
    d: "M139.3,78L97.7,5.7 C95.7,2.1,91.5-0.1,87.4,0C84,0.1,81,2.1,79.3,5L1.3,140.2c-1.7,2.9-1.7,6.5,0,9.4l78.2,135.4l8.8-26.6L25.4,149.5 c-1.7-2.9-1.7-6.5,0-9.4L88.2,31.4l33,57.1c1.5,2.6,4.8,3.4,7.4,1.9l8.8-5.2C139.9,83.8,140.8,80.5,139.3,78L139.3,78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183231176810250231520000018166828800544515236_",
    gradientUnits: "userSpaceOnUse",
    x1: -170.09,
    y1: 81.201,
    x2: 538.52,
    y2: 78.271,
    gradientTransform: "matrix(1 0 0 -1 0 291.7033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FF9933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#FFCC00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183231176810250231520000018166828800544515236_)"
    },
    d: "M320.4,134.4h-75.7c-3,0-5.4,2.4-5.4,5.4 V150c0,3,2.4,5.4,6.2,5.1h57.6l-0.1,0l-62.9,109c-1.7,2.9-4.8,4.7-8.1,4.7H106.3l30.5-52.8c1.5-2.6,0.6-5.8-2-7.3l-8.8-5.1 c-2.6-1.5-5.8-0.6-7.3,2l-39.3,68c-2,3.5-2,7.8,0,11.4l0.7,1.1c1.3,2.2,3.7,3.6,6.3,3.6H244c3.4,0,6.5-1.8,8.1-4.7l78.2-135.4 c1.7-2.9,1.7-6.6,0-9.5l0,0C328.3,136.6,324.5,134.4,320.4,134.4L320.4,134.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113327268345018532930000002125376392337833109_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.93,
    y1: 146.9766,
    x2: 219.66,
    y2: 146.9766,
    gradientTransform: "matrix(1 0 0 -1 0 291.7033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#FF9933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#FFCC00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113327268345018532930000002125376392337833109_)"
    },
    d: "M192.5,193l-24.1-48.1l36.4-48.4l7.1,14.9 c0.6,1.3,0.5,2.9-0.4,4.1l-23.8,31.8l14.5,29.1c0.7,1.4,0.5,3-0.4,4.2L192.5,193z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107569295607216281400000007445887962890510475_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.3765,
    y1: 199.8541,
    x2: 75.4865,
    y2: 17.9741,
    gradientTransform: "matrix(1 0 0 -1 0 291.7033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#FF9933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#FFCC00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107569295607216281400000007445887962890510475_)"
    },
    d: "M168.4,144.9h-60.2l6.1,12.2 c0.7,1.4,2.1,2.2,3.6,2.2h38.4l15.8,31.5c0.7,1.4,2.1,2.2,3.6,2.2h16.8L168.4,144.9L168.4,144.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002379962679869723740000012440840959373945520_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.3997,
    y1: 248.6433,
    x2: 223.5298,
    y2: 115.1833,
    gradientTransform: "matrix(1 0 0 -1 0 291.7033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#FF9933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#FFCC00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002379962679869723740000012440840959373945520_)"
    },
    d: "M188,96.5c-1.3,0-2.4,0.6-3.2,1.6 l-24.5,32.7l-39.4,0c-1.3,0-2.4,0.6-3.2,1.6l-9.4,12.5h60.2l36.4-48.4L188,96.5L188,96.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding);
export default __webpack_public_path__ + "static/media/branding.9c9a2e567b08bae056cbedb03185a5dd.svg";
export { ForwardRef as ReactComponent };